import {createSlice} from "@reduxjs/toolkit";

const initialTemplatesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  templateForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const templatesSlice = createSlice({
  name: "templates",
  initialState: initialTemplatesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    // getTemplateById
    templateFetched: (state, action) => {
      state.listLoading = false;
      state.templateForEdit = action.payload.templateForEdit;
      state.error = null;
    },
    // findTemplates
    templatesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createTemplate
    templateCreated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      console.log(action);
      state.entities.push(action.payload.template);
    },
    // updateTemplate
    templateUpdated: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.idTemplate === action.payload.template.idTemplate) {
          return action.payload.template;
        }
        return entity;
      });
    },
    // deleteTemplate
    templateDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteTemplates
    templatesDeleted: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // templatesUpdateState
    templatesStatusUpdated: (state, action) => {
      state.listLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
